/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IDocumentRepository } from '@/modules/documents/domain/repositories/document.repository';

import { GetAllDocuments } from '../queries/get-all-documents';

export namespace DeleteDocument {
  export type Input = IDocumentRepository.DeleteInput;
  export type Output = IDocumentRepository.DeleteOutput;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const { repositories } = useDependencies();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn: (input) => repositories.document.delete(input),
      async onSuccess(_, variables) {
        await queryClient.invalidateQueries({
          queryKey: GetAllDocuments.key(variables),
        });
      },
    });
  }
}
